export const SIGNUP = 'SIGNUP';
export const SIGNUP_SUCCESS='SIGNUP_SUCCESS';
export const SIGNUP_FAILURE='SIGNUP_FAILURE';
export const LOGOUT='LOGOUT';

export const signUp = (data) => {
    return {
        type: SIGNUP,
        data
    }
}
export const signUpSuccess = (data) => {
    return {
        type: SIGNUP_SUCCESS,
        data
    }
}
export const signUpFailure = (data) => {
    return {
        type: SIGNUP_FAILURE,
        data
    }
}

export const SET_USER_DETAILS = 'SET_USER_DETAILS';
export const  setUserDetails = (data) => {
    return {
        type: SET_USER_DETAILS,
        data
    }
}

export const logout = () => {
    return {
        type:LOGOUT
    }
}
